import { Button } from '@/components/ui/button'
import { checkLine, type FillCheck } from '@/models/fillApplication'
import { useFillJump } from './FillJumpProvider'

interface MissingItemsListProps {
  items: FillCheck[]
  /** Runs before the jump, e.g. to close the dialog the list sits in. */
  onJump?: () => void
}

export function MissingItemsList({ items, onJump }: MissingItemsListProps) {
  const { jump } = useFillJump()

  return (
    <ul className="flex flex-col gap-1">
      {/* Two rows can read the same, e.g. unnamed drivers, so the position keeps their keys apart. */}
      {items.map((item, index) => (
        <li key={`${index}-${item.field}-${item.label}`}>
          <Button
            type="button"
            variant="link"
            size="sm"
            className="h-auto px-0 text-left whitespace-normal"
            onClick={() => {
              onJump?.()
              jump(item)
            }}
          >
            {checkLine(item)}
          </Button>
        </li>
      ))}
    </ul>
  )
}
